let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZinD"), load("kQvbt"), load("gQSWJ"), load("4fCJZ"), load("6JvQz")]).then(() => parcelRequire('4ikYV'));